var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfternoonNotAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Afternoon-not-available"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4200",
    x: 1.16406,
    y: 0.5,
    width: 27.3625,
    height: 20.78,
    rx: 5.5,
    fill: "white",
    stroke: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M17.1421 13.1009H13.3591L12.7091 14.9469H11.1621L14.3991 5.8989H16.1151L19.3521 14.9469H17.7921L17.1421 13.1009ZM16.7261 11.8919L15.2571 7.6929L13.7751 11.8919H16.7261Z",
    fill: "#233849"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 66",
    x1: 26.2817,
    y1: 3.41311,
    x2: 4.28167,
    y2: 18.4131,
    stroke: "#B0AFAF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfternoonNotAvailable);
export default __webpack_public_path__ + "static/media/Afternoon-not-available.77e5bfae80111fe3fa6c996e57fcbe6d.svg";
export { ForwardRef as ReactComponent };